import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IntegrateState } from '../../state/integrate_state';
import { Store } from '@ngrx/store';
import { REDCRSS_EVENTS } from '../../../../shared/services/constants/redcross_evemts';
import { InstallAutomaticallyApprovalComponent } from '../../dialog_content/install_automatically_approval.component';
import { isSupportedPlatform, PlatformType } from '../../platform_type';
import { SendToDeveloperComponent } from '../../dialog_content/send_to_developer.component';
import { InstallItMyselfComponent } from '../../dialog_content/install_it_myself.component';
import { PlatformService } from '../../../../shared/services/platforms/platform.service';
import { navOpenManualInstall } from '../../../shared/navigation/state/navigation_actions_creator';
import { IAppState } from '../../../../app_state';
import { map, take } from 'rxjs/operators';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-integrate-main',
  template: require('./integrate_menu.component.html'),
  styles: [require('./integrate_menu.component.scss')]
})
export class IntegrateMainComponent implements OnInit {

  dialogContent = null;
  showDialog = false;
  title = 'INTEGRATE.INSTALL_TITLE';
  subTitle = 'INTEGRATE.INSTALL_SUB_TITLE';
  HCLink = 'https://support.yotpo.com/en/article/shopify-installing-yotpo-reviews-on-online-store-20';
  shouldShowGif = false;
  isWidgetV3: boolean;

  constructor(
    private redCrossService: AnalyticsTrackingProvider,
    private store: Store<IAppState>,
    private platformService: PlatformService
  ) {
    this.showActions().pipe(take(1)).subscribe(
      (shouldShowAction) => {
        if (!shouldShowAction) {
          this.title = 'INTEGRATE.INSTALL_COMPLETED_TITLE';
          this.subTitle = 'INTEGRATE.INSTALL_COMPLETED_SUB_TITLE';
        }
      });
    let skipMainIntegrationPage = false;
    this.store.select(state => state.app.install.navigation).pipe(take(1)).subscribe(
      items => {
          let shouldSkip = items.navigationItems.some(item => item.skipMainIntegrationPage === true);
          if (shouldSkip) {
            skipMainIntegrationPage = true;
        }
      }
    );
    if (skipMainIntegrationPage) {
      this.switchToManualInstalltion();
    }
    this.store.select(state => state.app.install.integrate).pipe(take(1)).subscribe(
      items => {
        this.isWidgetV3 = items.hasWidgetV3;
      });
  }

  showAutomaticInstall(): Observable<boolean> {
    return this.store.select(state => state.app.install.integrate).pipe(map((state: IntegrateState) => {
      return state.platform === PlatformType.Shopify && state.platformErrors.length === 0;
    }));
  }

  showActions(): Observable<boolean> {
    return this.store.select(state => state.app.install.integrate).pipe(map((state: IntegrateState) => {
      return !this.platformService.isVolusion2PlatformType(state.platform);
    }));
  }

  isShopify2(): Observable<boolean> {
    return this.store.select(state => state.app.install.integrate).pipe(map((state: IntegrateState) => {
      return !!state.shopifyDeeplink;
    }));
  }

  shopDeeplink(): Observable<string> {
    return this.store.select(state => state.app.install.integrate).pipe(map((state: IntegrateState) => {
      return state.shopifyDeeplink;
    }));
  }

  ngOnInit() {
    this.redCrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, { pageCategory: 'Installation V2' });
    this.redCrossService.page(REDCRSS_EVENTS.ONBOARDING,
      {
        category: 'Reviews',
        phaseName: 'Onboarding Step 3',
        phase: 3,
        status: 'started'
      });
    this.isShopify2().subscribe(res => {
      if (res) {
        this.redCrossService.track(REDCRSS_EVENTS.ACTIVATION_STEP, {
          product: REDCRSS_EVENTS.PRODUCT,
          stepName: 'Install Widget',
          stepNum: 3,
          status: 'Started',
          os20: true
        });
      }
    });
    this.redCrossService.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: REDCRSS_EVENTS.INTEGRATE,
      stepNum: 3,
      status: REDCRSS_EVENTS.STARTED,
      isWidgetV3: this.isWidgetV3
    });
  }

  onAutomaticInstallation() {
    this.redCrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Do it for me',
      ctaName: 'Install Automatically'
    });

    this.redCrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaLocation: 'Reviews Onboarding',
      ctaName: 'Integrate',
      ctaText: 'Install Now'
    });

    this.showDialog = true;
    this.dialogContent = InstallAutomaticallyApprovalComponent;
  }

  switchToManualInstalltion() {
    this.store.select(state => state.app.install.integrate).subscribe((state: IntegrateState) => {
      if (!isSupportedPlatform(state.platform)) {
        this.showDialog = true;
        this.dialogContent = InstallItMyselfComponent;
      } else {
        this.store.dispatch(navOpenManualInstall());
      }
    });
  }

  onManualInstallation() {
    this.redCrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'I will do it',
      ctaName: 'Install myself'
    });

    this.redCrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaLocation: 'Reviews Onboarding',
      ctaName: 'Integrate',
      ctaText: 'See Instructions'
    });

    this.switchToManualInstalltion();
  }

  onSendToDeveloper() {
    this.redCrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: REDCRSS_EVENTS.SEND_EMAIL,
      ctaName: REDCRSS_EVENTS.SEND_EMAIL
    });

    this.redCrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaLocation: 'Reviews Onboarding',
      ctaName: 'Integrate',
      ctaText: 'Send to Developer'
    });

    this.showDialog = true;
    this.dialogContent = SendToDeveloperComponent;
  }

  closeDialog() {
    this.showDialog = false;
  }

  moveToNextDialog(component) {
    this.dialogContent = component;
  }

  hcClick() {
    this.redCrossService.track(REDCRSS_EVENTS.BUTTON_CLICK, {
      product: REDCRSS_EVENTS.PRODUCT,
      btnContext: 'Reviews Activation',
      btnLocation: 'Onboarding Install Widget',
      btnName: 'Help Center',
      btnText: 'Help Center Article',
      os20: true
    });
  }
}
